import makeRequest from "./makeRequest";
import getRuntimeConstants from "../runtimeConstants";
import getWindow from "../utils/window";
import { GET } from "../constants";

// Stubbed pages serve stub review ids, which only resolve against the stubbed origin.
const getStubbedSiteOrigin = () => {
  const siteOrigin = new URLSearchParams(
    getWindow()?.location?.search ?? "",
  ).get("x-site-origin");

  return siteOrigin?.includes("stubbed") ? siteOrigin : null;
};

export function getReviewTranslation({ productId, reviewId, store }) {
  const {
    ratingsApiPath,
    reviewsTranslationApiUrl,
    reviewsTranslationXSiteOrigin,
  } = getRuntimeConstants();
  const baseUrl = reviewsTranslationApiUrl || ratingsApiPath;
  const siteOrigin = getStubbedSiteOrigin() || reviewsTranslationXSiteOrigin;

  return makeRequest({
    url: `${baseUrl}/${productId}/reviews/${reviewId}/translation`,
    method: GET,
    params: { store },
    headers: siteOrigin ? { "x-site-origin": siteOrigin } : undefined,
    requestType: "REVIEWS_API",
    apiName: "Review Translation",
    caller: "Review",
    handleErrorReturnValue: () => null,
  });
}
